import { useLang } from "@/context/LanguageContext";

const STATUS_STYLES = {
  DRAFT:             "bg-yellow-100 text-yellow-800 border border-yellow-300 dark:bg-yellow-900/40 dark:text-yellow-300 dark:border-yellow-700",
  READY:             "bg-blue-100 text-blue-800 border border-blue-300 dark:bg-blue-900/40 dark:text-blue-300 dark:border-blue-700",
  IN_TRANSIT:        "bg-cyan-100 text-cyan-800 border border-cyan-300 dark:bg-cyan-900/40 dark:text-cyan-300 dark:border-cyan-700",
  RECEIVED:          "bg-emerald-100 text-emerald-800 border border-emerald-300 dark:bg-emerald-900/40 dark:text-emerald-300 dark:border-emerald-700",
};

const STATUS_DOTS = {
  DRAFT:             "bg-yellow-500",
  READY:             "bg-blue-500",
  IN_TRANSIT:        "bg-cyan-500",
  RECEIVED:          "bg-emerald-500",
};

export default function StatusBadge({ status, className = "" }) {
  const { t } = useLang();
  const style = STATUS_STYLES[status] || "bg-slate-100 text-slate-800 border border-slate-300 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600";
  const dot   = STATUS_DOTS[status]  || "bg-slate-500";
  const label = t(`status.${status}`) || status;

  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold ${style} ${className}`}>
      <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
      {label}
    </span>
  );
}
